import { render } from "./CallDataReservation.vue?vue&type=template&id=46d1e237"
import script from "./CallDataReservation.vue?vue&type=script&lang=js"
export * from "./CallDataReservation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__